import { render, staticRenderFns } from "./card-admin-mural.vue?vue&type=template&id=0ad68cfb&scoped=true&"
import script from "./card-admin-mural.vue?vue&type=script&lang=js&"
export * from "./card-admin-mural.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad68cfb",
  null
  
)

export default component.exports